import { FC } from 'react'
import s from './Overlay.module.sass'

interface OverlayProps {
  className?: string
  onClick?: () => void
}

export const Overlay: FC<OverlayProps> = (props) => {
  const { className, onClick } = props
  const thisClassName = `${s.overlay} ${className || ''}`
  return <div className={thisClassName} onClick={onClick} />
}
